export interface OpportunityDetailFetchOptions {
  includeSimilar?: boolean
  includePresignedUrls?: boolean
}

export const buildOpportunityDetailQueryString = (
  options?: OpportunityDetailFetchOptions,
) => {
  const params = new URLSearchParams()

  if (options?.includeSimilar) {
    params.set('include_similar', 'true')
  }
  if (options?.includePresignedUrls === false) {
    params.set('include_presigned_urls', 'false')
  }

  const queryString = params.toString()
  return queryString ? `?${queryString}` : ''
}
